module.exports = __webpack_public_path__ + "img/facecam.9ae44189.png";